import {ICalendarPublishData, ICalendarWriteData, IMonitoredDataPayload, IPublishData} from "@lib/types"
import { Config } from "./cfg";

const CREATE_DATA_SUB = '/Methods/CreateDataSubscription'

const CREATE_MONITPRED_DATA_ITEMS = '/Methods/CreateMonitoredDataItems'

const DELETE_MONITPRED_DATA_ITEMS = '/Methods/DeleteMonitoredDataItems'

const PUBLISH_DATA = '/Methods/PublishData'

const WRITEDATA = "/Methods/WriteData";


export class MSSub extends Config {
    subscriptionId?: number
    ackSequenceNumber: number = 0
    // sessionId: number

    subscriptionMap = new Map<NodeJS.Timeout, {
        past: any | null
        curr: any | null
    }>()

    constructor() {
        super()
        this.afterSwitchBind = this.afterSwitch.bind(this);
        window.addEventListener("ms_message", this.afterSwitchBind);
    }

    afterSwitch(message) {
        const data = message.data;
        switch (data.event) {
            case "serverChanged":
                const baseUrl = $sw.serverState.haveReserv
                    ? `//${$sw.serverState.location.hostname}:${window.location.port}`
                    : `//${window?.location.hostname}:${window?.location.port}`;

                // Изменяем baseURL в экземпляре axios
                this.req.defaults.baseURL = baseUrl;
                
                break;
        }
    }

    async CraeteDataSubscription() {
        const payload = {
            sessionId: this.sessionId
        }

        const res = await this.req.post(CREATE_DATA_SUB, payload)

        this.subscriptionId = res.data.subscriptionId
    }

    async CraeteMonitoredDataItems(items: Array<IMonitoredDataPayload>) {
        const payload = {
            sessionId: this.sessionId,
            subscriptionId: this.subscriptionId,
            items
        }

        const res = await this.req.post(CREATE_MONITPRED_DATA_ITEMS, payload)

        this.subscriptionId = res.data.subscriptionId

        return res.data
    } 

    async DeleteMonitoredDataItems(items: Array<number>) {
        const payload = {
            sessionId: this.sessionId,
            subscriptionId: this.subscriptionId,
            items
        }

        await this.req.post(DELETE_MONITPRED_DATA_ITEMS, payload)
    }

    async PublishData(ackSequenceNumber: number): Promise<IPublishData<ICalendarPublishData>> {
        
        const payload = {
            sessionId: this.sessionId,
            subscriptionId: this.subscriptionId,
            ackSequenceNumber: ackSequenceNumber,
        }

        const res = await this.req.post(PUBLISH_DATA, payload)

        return res.data
    }
 
    async WriteData(recs: Array<ICalendarWriteData>) {
        try {
          const res = await this.req.post(WRITEDATA, {
            sessionId: this.sessionId,
            recs 
          });
    
        } catch (e) {
          console.log("Error in WriteData ", e);
        }
      }

    get sessionId() {
        return window.$sw.sessionId
    }
}